module.exports = __webpack_public_path__ + "media/images/top/information_hr-bc25cd12e22ed3855412a2679a9fa1b4.png";